import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  ButtonNewRecord,
  FlexRow,
  TableDataState,
  TableEditButtons,
  usePaginatedQueryV8,
} from 'motion-components';

import { Card } from 'react-bootstrap';
import { useRootStore } from 'store';
import { useHandleError } from 'shared-pages/services';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues, Filters } from './filters';
import { GridPage } from './grid';
import { handleExport } from './export-columns';
import { useApolloClient } from '@apollo/client';
import { getRouteByName } from 'app/routes';
import { generatePath, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useUserLocationPermissions } from 'shared-pages/hooks';
import { observer } from 'mobx-react-lite';

export const CollectionsGridPage = observer(
  ({
    collectionPointId,
    isGridInForm = false,
    isModal = false,
  }: {
    collectionPointId?: number;
    isGridInForm?: boolean;
    isModal?: boolean;
  }) => {
    const { appStore, tableStore } = useRootStore();
    const { handleGraphqlError } = useHandleError('CollectionOrdersGridPage');

    const location = useLocation<any>();
    const history = useHistory();
    const [selected, setSelected] = useState<any>(null);
    const { t } = useTranslation();

    const canAddNew =
      appStore.isPlatformOwner || appStore.isCollector || appStore.isCollectorDriver;

    const persistedValues = isGridInForm ? { collectionPointId } : {};

    /* ------------------- Query ------------------------------- */
    const initOrderBy = 'dateCollected DESC';
    const query = usePaginatedQueryV8(
      gqlGetQuery,
      buildWhereFromFilterValues,
      location.state?.order ?? initOrderBy,
      appStore,
      true,
      { isActive: true, collectionPointId: collectionPointId },
      !isGridInForm, // History Replace
      !isGridInForm ? undefined : 'collections_grid', //'collections_grid',
      persistedValues,
    );
    const {
      loading,
      data,
      dataCount,
      error,
      initPageIndex,
      filtersChanged,
      gridPageChanged,
      queryState,
      queryParams,
      setQueryParams,
      refetch,
    } = query;

    const client = useApolloClient();

    const handleCreateNew = useCallback(() => {
      history.push({
        pathname: generatePath(getRouteByName('Collection'), { id: -1 }),
        state: {
          pathname: location.pathname,
          ...location.state,
        },
      });
    }, [history, location.pathname, location.state]);

    const gridRef = useRef();
    console.log('persistedValues', persistedValues);
    if (error) {
      handleGraphqlError('query-get', error);
      return <h3 className="text-center">{error.message}</h3>;
    } else {
      return (
        <Card className="shadow">
          {!isGridInForm && (
            <Card.Header>
              <FlexRow>
                <Card.Title className="m-0">{t('Συλλογές Αποβλήτων')}</Card.Title>
                {canAddNew && (
                  <ButtonNewRecord onClick={handleCreateNew} size="sm" label="Νέα Συλλογή" />
                )}
              </FlexRow>
            </Card.Header>
          )}

          <Card.Body className="nopadding">
            {/* Φίλτρα */}
            {!isModal && (
              <Filters
                onChange={filtersChanged}
                // initialValues={!isGridInForm ? queryState?.filterValues ?? {} : {}}
                initialValues={queryState?.filterValues}
                disable={tableStore.state !== TableDataState.browse}
                isGridInForm={isGridInForm}
              />
            )}

            {/* Grid */}
            <GridPage
              ref={gridRef}
              loading={loading}
              data={data}
              dataCount={dataCount}
              initPageIndex={initPageIndex}
              onPageChange={gridPageChanged}
              handleExport={() => {
                handleExport(client, queryState, t);
              }}
              initOrderBy={queryParams?.order ?? initOrderBy}
              onOrderChange={(orderBy) => {
                const newQueryParams = { ...queryParams, order: orderBy };
                setQueryParams(newQueryParams);
                if (!isGridInForm) {
                  history.replace({
                    pathname: location.pathname,
                    state: {
                      ...location.state,
                      order: orderBy,
                    },
                  });
                }
              }}
              selected={selected}
              setSelected={setSelected}
              refetch={refetch}
              isGridInForm={isGridInForm}
            />
          </Card.Body>
        </Card>
      );
    }
  },
);

